import { Puck } from "@measured/puck";
import "@measured/puck/puck.css";
import { configPUCK } from "./config";
import { Button } from "reactstrap";
import { useState, useRef } from "react";
import http from "../../services/http";

// Describe the initial data
const initialData = {};

export default function PageBuilder() {
  // State to hold the editor's current data
  const [editorData, setEditorData] = useState(initialData);

  // Create a ref to the Puck editor
  const puckRef = useRef(null);

  // Function to handle manual saving of the editor data
  const handleSave = async () => {
    try {
      const payload = {
        PK: "PAGES#",
        SK: "USER#123",
        item_data: {
          content: editorData,
        },
      };
      const { data: resp } = await http.post(
        "https://a9yd2tumde.execute-api.us-east-1.amazonaws.com/dev/db/save-data",
        payload
      );
    } catch (e) {
      console.log(e.message);
    }
  };

  // Function that is called when Puck publishes (updates) the data automatically
  const save = (data) => {
    setEditorData(data); // Update state with the latest editor data
  };

  return (
    <div className="page-body">
      <Puck
        ref={puckRef} // Attach the Puck editor ref
        config={configPUCK}
        data={initialData}
        onChange={setEditorData}
      />
      <Button color="primary" onClick={handleSave}>
        Save Content
      </Button>
    </div>
  );
}
